/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import latestAd from "../assets/img/latest-ad.jpg";
import Background from "../assets/img/dismantlers/box-bg.jpg";
import { Swiper, SwiperSlide } from 'swiper/react';
import {Navigation} from "swiper";

import 'swiper/css';
import DismantlerLayout from "./DismantlerLayout";
import ScrollToTop from "./ScrollToTop";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const PageBox = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <ScrollToTop>
            <div className={`page-box ${ props.small ? 'page-box--small': '' } ${ props.smallbox ? 'page-box--small-box': '' }  ${ props.dismantler ? 'page-box--dismantler': '' }`} style={ props.dismantler ? { backgroundImage:`url(${Background})`} : {}}>
                { !props.small && <div className='page-box__header'>
                    <div className='container-block'>
                        <div className='page-box__title main-title'>{props.data.title}</div>
                        <div className='page-box__subtitle medium-text'>{props.data.subtitle}</div>
                    </div>
                </div> }
                <div className='page-box__body'>
                    <div className='container-block'>
                        <div className='container-block__inner bg-white block-shadow'>
                            {props.children}
                        </div>
                    </div>

                    { props.latestAds.length > 0 && <div className='container-block'>
                        <div className='latest-ads'>
                            <div className='latest-ads__title'>Latest Ads</div>
                            <div className='latest-ads__body'>

                                <Swiper
                                    spaceBetween={20}
                                    slidesPerView={"auto"}
                                    navigation={true}
                                    modules={[Navigation]}
                                >
                                    {
                                        props.latestAds.map( (ad, index) => (
                                            <SwiperSlide key={index}>
                                                <Link to={`/${i18n.language}/used-part/${ad.slug}/${ad.make_slug}/${ad.model_slug}/${ad.date_range}/${ad.city_slug}/${ad.part_code}`} className='latest-ad'>
                                                    <div className='latest-ad__img'>
                                                        { ad.main_image && <img src={ad.main_image} alt={ad.title} /> }
                                                    </div>
                                                    <div className='latest-ad__body'>
                                                        <div className='latest-ad__cat'>{ad.model_name}</div>
                                                        <div className='latest-ad__title'>{ad.title}</div>
                                                        <div className='latest-ad__ref'>{ad.code}</div>
                                                        <div className='latest-ad__row'>
                                                            {
                                                                ad.part_numbers.map( (item, index) => (
                                                                    <div className='btn latest-ad__model' key={index}>{item.part_number}</div>
                                                                ) )
                                                            }
                                                        </div>
                                                        <div className='latest-ad__price-box'>
                                                            <div className='latest-ad__price-label'>VAT FREE</div>
                                                            <div className='latest-ad__price'>{ad.price}€</div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        ) )
                                    }

                                    {/*<SwiperSlide>*/}
                                    {/*    <a href='#' className='latest-ad'>*/}
                                    {/*        <div className='latest-ad__ing'><img src={latestAd} alt='car' /> </div>*/}
                                    {/*        <div className='latest-ad__body'>*/}
                                    {/*            <div className='latest-ad__cat'>RAV 4 (XA20) </div>*/}
                                    {/*            <div className='latest-ad__title'>FRONT DOOR SPEAKER</div>*/}
                                    {/*            <div className='latest-ad__ref'>8616042110</div>*/}
                                    {/*            <div className='latest-ad__row'>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='latest-ad__price-box'>*/}
                                    {/*                <div className='latest-ad__price-label'>VAT FREE</div>*/}
                                    {/*                <div className='latest-ad__price'>40€</div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </a>*/}
                                    {/*</SwiperSlide>*/}
                                    {/*<SwiperSlide>*/}
                                    {/*    <a href='#' className='latest-ad'>*/}
                                    {/*        <div className='latest-ad__ing'><img src={latestAd} alt='car' /> </div>*/}
                                    {/*        <div className='latest-ad__body'>*/}
                                    {/*            <div className='latest-ad__cat'>RAV 4 (XA20) </div>*/}
                                    {/*            <div className='latest-ad__title'>FRONT DOOR SPEAKER</div>*/}
                                    {/*            <div className='latest-ad__ref'>8616042110</div>*/}
                                    {/*            <div className='latest-ad__row'>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='latest-ad__price-box'>*/}
                                    {/*                <div className='latest-ad__price-label'>VAT FREE</div>*/}
                                    {/*                <div className='latest-ad__price'>40€</div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </a>*/}
                                    {/*</SwiperSlide>*/}
                                    {/*<SwiperSlide>*/}
                                    {/*    <a href='#' className='latest-ad'>*/}
                                    {/*        <div className='latest-ad__ing'><img src={latestAd} alt='car' /> </div>*/}
                                    {/*        <div className='latest-ad__body'>*/}
                                    {/*            <div className='latest-ad__cat'>RAV 4 (XA20) </div>*/}
                                    {/*            <div className='latest-ad__title'>FRONT DOOR SPEAKER</div>*/}
                                    {/*            <div className='latest-ad__ref'>8616042110</div>*/}
                                    {/*            <div className='latest-ad__row'>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='latest-ad__price-box'>*/}
                                    {/*                <div className='latest-ad__price-label'>VAT FREE</div>*/}
                                    {/*                <div className='latest-ad__price'>40€</div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </a>*/}
                                    {/*</SwiperSlide>*/}
                                    {/*<SwiperSlide>*/}
                                    {/*    <a href='#' className='latest-ad'>*/}
                                    {/*        <div className='latest-ad__ing'><img src={latestAd} alt='car' /> </div>*/}
                                    {/*        <div className='latest-ad__body'>*/}
                                    {/*            <div className='latest-ad__cat'>RAV 4 (XA20) </div>*/}
                                    {/*            <div className='latest-ad__title'>FRONT DOOR SPEAKER</div>*/}
                                    {/*            <div className='latest-ad__ref'>8616042110</div>*/}
                                    {/*            <div className='latest-ad__row'>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*                <div className='btn latest-ad__model'>65245565</div>*/}
                                    {/*                <div className='btn latest-ad__model'>33026502</div>*/}
                                    {/*            </div>*/}
                                    {/*            <div className='latest-ad__price-box'>*/}
                                    {/*                <div className='latest-ad__price-label'>VAT FREE</div>*/}
                                    {/*                <div className='latest-ad__price'>40€</div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </a>*/}
                                    {/*</SwiperSlide>*/}

                                </Swiper>

                            </div>
                        </div>
                    </div>}

                </div>
            </div>
        </ScrollToTop>
    );
};

PageBox.defaultProps  = {
    showAds: false,
    smallbox: false,
    small: false,
    dismantler: false,
    latestAds: []
}


export default PageBox;
